<template>
  <div class="video-bg-wrap">
    <!-- :poster="poster" -->
    <video
      ref="bgvid"
      :src="src"
      style="width: 100%; height: 100%; object-fit: cover;"
      data-autoplay=""
      muted="muted"
      loop="loop"
      @play="playCb"
    ></video>
  </div>
</template>

<script>
export default {
  name: "VideoBgWrap",
  props: {
    src: {
      type: String,
      default: ""
    },
    poster: {
      type: String,
      default: ""
    }
  },
  data: () => ({
  }),
  watch: {
    src() {
      this.$nextTick(this.playBgVid);
    }
  },
  created() {
    document.addEventListener("click", this.playBgVid);
  },
  mounted() {
    this.playBgVid();
  },
  methods: {
    playBgVid() {
      this.$refs.bgvid.play();
      this.playCb();
    },
    playCb() {
      document.removeEventListener("click", this.playBgVid);
    }
  }
};
</script>
<style lang="less" scoped>
.video-bg-wrap {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  // background: url("~@/assets/images/bg_01.jpg") no-repeat center top;
  // background-size: cover;
  transform: translate(-50%, -50%);
  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
</style>
